/**
 * @generated SignedSource<<da1836ec75527553c6bb1ad442ca2d69>>
 * @relayHash a66b182c1e98d29a24ccc39146246ff5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad2942e63f580fdb10e21b5aa2bea007bbf7d1f0c03a65aad53b29d9310a0ffe

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CaseNotesPageQuery } from './CaseNotesPageQuery.graphql';

const node: PreloadableConcreteRequest<CaseNotesPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ad2942e63f580fdb10e21b5aa2bea007bbf7d1f0c03a65aad53b29d9310a0ffe",
    "metadata": {},
    "name": "CaseNotesPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
